import React from 'react';
import styles from 'components/button/index.module.scss';
import cn from 'classnames/bind';
import LoadingIcon from 'components/button/loading-icon';

const cx = cn.bind(styles);

/**
 * @param theme {'default'|'brown'|'blue'|'link'|'black'}
 * @param loading {boolean}
 * @param block {boolean}
 * @param onClick {function}
 * @param disabled {boolean}
 * @param children {ReactDOM}
 */
const Button = ({
  theme = 'default',
  loading = false,
  block = false,
  onClick,
  disabled,
  children,
  style,
  className,
}) => {
  const buttonClasses = cx({
    button: true,
    [theme]: true,
    loading,
    block,
    disabled,
    [className]: true,
  });

  return (
    <button className={buttonClasses} disabled={disabled} onClick={onClick} style={style}>
      {loading ? <LoadingIcon /> : children}
    </button>
  );
};

export default Button;
